module.exports = __webpack_public_path__ + "img/compass.18dd19a4.svg";